import { useState } from "react";
import { ArrowUpOnSquareIcon } from "@heroicons/react/24/outline";
import { IoCloudUploadOutline } from "react-icons/io5";
import toast from "react-hot-toast";

type ImageUploadComponentProps = {
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement>, index: number) => void;
  index?: number;
  text?: string;
  heading?: string;
  data: any;
  multiple?: boolean;
  required?: boolean; // Add required prop
};

const ImageUploadComponent: React.FC<ImageUploadComponentProps> = ({
  handleFileChange,
  index,
  text,
  data,
  heading,
  multiple = true,
  required = false, // Default to false if not passed
}) => {
  const [fileSelected, setFileSelected] = useState<boolean>(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const file = e.target.files?.[0];

    if (file) {
      const fileSizeInMB = file.size / (1024 * 1024); // Convert bytes to MB

      if (fileSizeInMB > 5) {
        // show error and prevent update
        toast.error("Image size cannot exceed 5 MB");
        e.target.value = ""; // clear input
        setFileSelected(false);
        return;
      }

      handleFileChange(e, index);
      setFileSelected(true);
    } else {
      setFileSelected(false);
    }
  };

  return (
    <>
      {data?.length > 0 ? (
        <label htmlFor={`file-input-${index}`} className="cursor-pointer">
          <input
            type="file"
            accept="image/*,application/pdf"
            className="hidden"
            multiple={multiple}
            id={`file-input-${index}`}
            onChange={(e) => handleChange(e, index)}
          />
          <div className="flex flex-col gap-1 pb-2 pl-0">
            <div className="flex items-center gap-2">
              <ArrowUpOnSquareIcon className="w-5 h-5 text-[#0068FF]" />
              <p className="text-[#0068FF] text-sm font-medium pt-1">Upload More</p>
            </div>
          </div>
        </label>
      ) : (
        <label
          htmlFor={`file-input-${index}`}
          className={`p-3 w-full h-[140px] border-dotted border-2 ${required && !fileSelected ? "border-dotted " : "border-dotted"} rounded-lg my-2 bg-white flex items-center justify-center relative cursor-pointer`}
        >
          <input
            type="file"
            required={required}
            accept="image/*,application/pdf"
            className="hidden"
            multiple={multiple}
            id={`file-input-${index}`}
            onChange={(e) => handleChange(e, index)}
          />
          <div className="flex items-center justify-center flex-col gap-1">
            <div className="h-10 w-10 border border-gray-300 rounded-xl flex justify-center items-center">
              <IoCloudUploadOutline className="w-5 h-5 text-gray-400" />
            </div>
            <div className="flex items-center gap-2">
              <p className="text-[#0068FF] text-sm font-semibold pt-1">{heading || "Upload"}</p>
            </div>
            <p className="text-gray-400 text-xs">{text}</p>
          </div>
        </label>
      )}
    </>
  );
};

export default ImageUploadComponent;
